import React from "react";
import { Button } from "@mui/material";
import { icons } from "../../../../svg";
import {
  findSelectedMonthOption,
  formatProductName,
} from "../../multiLocQuoteDetailsPanel/multiLocQuoteDetailsUtils";
import { FooterSelectorButtonsProps } from "../../../../types/IMultiLocationQuoteMobile";

const FooterSelectorButtons: React.FC<FooterSelectorButtonsProps> = ({
  selectedProduct,
  selectedMonth,
  months,
  onProductClick,
  onMonthClick,
}) => {
  const selectedMonthDisplay =
    findSelectedMonthOption(months, selectedMonth)?.display ||
    "Select Month";

  return (
    <>
      <Button
        id="mobile-month-select-button"
        className="product-button-multi-loc"
        onClick={onMonthClick}
      >
        <span className="product-text" id="mobile-footer-month-select-button-text">
          {selectedMonthDisplay}
        </span>
        <img
          id="mobile-month-select-button-icon"
          src={icons.DownwardExpandIcon}
          alt="Downward Expand Icon"
          className="expand-icon expand-icon-inverted"
        />
      </Button>

      <Button
        id="mobile-product-select-button"
        className="product-button-multi-loc product-button-fixed-width"
        onClick={onProductClick}
      >
        <span className="product-text" id="mobile-product-select-button-text">
          {formatProductName(selectedProduct)}
        </span>
        <img
          id="mobile-product-select-button-icon"
          data-tooltip-id="downward-expand-icon"
          src={icons.DownwardExpandIcon}
          alt="Downward Expand Icon"
          className="expand-icon expand-icon-inverted"
        />
      </Button>
    </>
  );
};

export default FooterSelectorButtons;
